import * as Yup from 'yup'
import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useLayoutEffect, useRef, useCallback, useMemo } from 'react';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Form, FormikProvider, useFormik } from 'formik'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';

import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Tooltip,
  List,
  ListItem,
  Menu,
  Popover,
  Box,
  Grid,
  Paper,
  ListItemText,
  TextField,
  Autocomplete,
  FormControlLabel,
  Switch,
  Tabs,
  Tab,
  IconButton,
  InputAdornment
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user/list';
import ProductToolbar from 'src/components/_dashboard/user/list/ProductToolbar.js';
import ProductsSearch from 'src/components/_dashboard/blog/ProductsSearch.js';
import ProductsMenu from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import { COMPANY_NAME, REST_API, REST_API_END_POINT, UNITS } from '../../constants/Defaultvalues';
import moment from 'moment';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { LoadingButton } from '@material-ui/lab';
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup';
import { useSnackbar } from 'notistack';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { UploadMultiFile, UploadSingleFile } from 'src/components/upload';
import {
  experimentalStyled as styled,
} from '@material-ui/core/styles'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import UploadSingleImage from 'src/components/upload/UploadSingleImage';
import { supabase } from '../../supabase/supabaseClient';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: '' },
  { id: '', label: '', alignLeft: true },
  { id: 'qb', label: 'qb', alignLeft: true },
  { id: 'name', label: 'Name', alignLeft: true },
  { id: 'type_name', label: 'Type', alignLeft: true },
  { id: 'makeAsTask', label: 'Make\nTask', alignLeft: true },
  { id: 'makeInstallCard', label: 'Install\nCard', alignLeft: true },
  { id: 'jobCost', label: 'Job\nCost', alignLeft: true },
  { id: 'cost', label: 'Cost\n(Hourly)', alignLeft: true },
  { id: 'markup', label: 'Markup\n(%)', alignLeft: true },
  { id: 'total_cost', label: 'Total\nCost', alignLeft: true },
  { id: 'originInhouse', label: 'Origin', alignLeft: true },
  { id: 'status', label: 'Status', alignLeft: true },
  { id: 'options', label: '', alignLeft: true },
  { id: '', label: '', alignLeft: true },
];
const TABLE_HEAD_SUBCONT = [
  // { id: '' },
  { id: '', label: '', alignLeft: true },
  { id: 'qb', label: 'qb', alignLeft: true },
  { id: 'name', label: 'Name', alignLeft: true },
  { id: 'type_name', label: 'Type', alignLeft: true },
  { id: 'makeAsTask', label: 'Make\nTask', alignLeft: true },
  { id: 'makeInstallCard', label: 'Install\nCard', alignLeft: true },
  { id: 'jobCost', label: 'Job\nCost', alignLeft: true },
  { id: 'cost', label: 'Cost\n(Hourly)', alignLeft: true },
  { id: 'markup', label: 'Markup\n(%)', alignLeft: true },
  { id: 'total_cost', label: 'Total\nCost', alignLeft: true },
  { id: 'originInhouse', label: 'Origin', alignLeft: true },
  { id: 'status', label: 'Status', alignLeft: true },
  { id: 'options', label: '', alignLeft: true },
  { id: '', label: '', alignLeft: true },
];
const TABLE_HEAD_Inactive = [
  { id: '', label: '', alignLeft: true },
  { id: 'qb', label: 'qb', alignLeft: true },
  { id: 'name', label: 'Name', alignLeft: true },
  { id: 'type_name', label: 'Type', alignLeft: true },
  { id: 'makeAsTask', label: 'Make\nTask', alignLeft: true },
  { id: 'makeInstallCard', label: 'Install\nCard', alignLeft: true },
  { id: 'jobCost', label: 'Job\nCost', alignLeft: true },
  { id: 'cost', label: 'Cost\n(Hourly)', alignLeft: true },
  { id: 'markup', label: 'Markup\n(%)', alignLeft: true },
  { id: 'total_cost', label: 'Total\nCost', alignLeft: true },
  { id: 'originInhouse', label: 'Origin', alignLeft: true },
  { id: 'service', label: 'Service', alignLeft: true },
  { id: 'status', label: 'Status', alignLeft: true },
  { id: 'options', label: '', alignLeft: true },
  { id: '', label: '', alignLeft: true },
];
// ----------------------------------------------------------------------

const getInhouseLabel = (value) => {
  switch (Number(value)) {
    case 1:
      return 'Production';
    case 2:
      return 'Install';
    case 3:
      return 'T/S';
    case 0:
      return 'Sub Contract';
    case 4:
      return 'Estimate Services';
    case 5:
      return 'Design Services';
    case 6:
      return 'Admin Services';
    default:
      return '-';
  }
};

const serviceMoveOptions = [
  { value: 1, label: 'Production' },
  { value: 0, label: 'Sub Contract' },
  { value: 2, label: 'Install' },
  { value: 3, label: 'T/S' },
  { value: 4, label: 'Estimate Services' },
  { value: 5, label: 'Design Services' },
  { value: 6, label: 'Admin Services' },
];

// Filter out current tab from move options
const getAvailableServiceMoveOptions = (currentTab) => {
  const tabToInhouseMap = {
    'in_house': 1,
    'sub_contract': 0,
    'install': 2,
    'ts': 3,
    'estimate_services': 4,
    'design_services': 5,
    'admin_services': 6,
    'inactive_services': null
  };

  const currentInhouse = tabToInhouseMap[currentTab];
  return serviceMoveOptions.filter(option => option.value !== currentInhouse);
};

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

function descendingComparator(a, b, orderBy) {
  const aValue = a[orderBy] ? a[orderBy].toString() : '';
  const bValue = b[orderBy] ? b[orderBy].toString() : '';
  return bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  
  const sortedArray = stabilizedThis.map((el) => el[0]);
  
  if (query) {
    // return filter(array, (_user) => {
    //   const nameMatch = _user.name && _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    //   const tagsMatch = _user.tags && _user.tags.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    const queryLower = query.toLowerCase().replace(/\s+/g, ' ').trim();
    return filter(sortedArray, (_user) => {
      const nameMatch = _user.name && _user.name.replace(/\s+/g, ' ').trim().toLowerCase().includes(queryLower);
      const tagsMatch = _user.tags && _user.tags.replace(/\s+/g, ' ').trim().toLowerCase().includes(queryLower);
      return nameMatch || tagsMatch;
    });
  }
  
  // return stabilizedThis.map((el) => el[0]);
  return sortedArray;
}

function scrollDashboardAncestorsToTop(fromNode) {
  if (typeof window === 'undefined' || !fromNode) return
  const { documentElement, body } = document
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  documentElement.scrollTop = 0
  body.scrollTop = 0

  let el = fromNode
  while (el) {
    const { overflowY } = window.getComputedStyle(el)
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight
    ) {
      el.scrollTop = 0
    }
    el = el.parentElement
  }
}

export default function LabourCostList({fromEstimateJob,setOpenServiceModal,serviceNameForAdd,onClose,selectedServiceForCatalog,setSelectedServiceForCatalog,filteredServices,openEditServiceModal,serviceDescForAdd}) {
  console.log("serviceDescForAdd",serviceDescForAdd)
  const theme = useTheme();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(true)
  const paginationScrollAnchorRef = useRef(null)
  const skipPaginationScrollRef = useRef(true)
  const prevLoadingForPaginationScrollRef = useRef(loading)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [debouncedFilterName, setDebouncedFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [ProductList, setProductList] = useState([]);
  const [labourCostServiceTypes, setLabourCostServiceTypes] = useState([]);
  const [viewData, setViewData] = useState(null);
  const isAdd = fromEstimateJob ? true : false;
  const [add, setAdd] = useState(isAdd);
  const [isDelete, setIsDelete] = useState(false)
  const [data, setSingleData] = useState(selectedServiceForCatalog || null);
  const [Id, setId] = useState(null)
  const [refreshData, setRefreshData] = useState(false)
  const [workflows, setWorkflows] = useState([])
  const [recentlyMovedIds, setRecentlyMovedIds] = useState([]);
  const navigate = useNavigate()
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions = userData?.exploded_permissions
  const [inHouse, setInHouse] = useState(1)
  ///this is for the tabs for inHouse and SubContract
  const [selectedTab, setSelectedTab] = useState('in_house');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openCloseAutoSaveConfirm, setOpenCloseAutoSaveConfirm] = useState(false);
  const closeAutoSaveSourceRef = useRef('modal'); // 'modal' | 'cancel'
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [moveTarget, setMoveTarget] = useState(null);
  const [moveAnchorEl, setMoveAnchorEl] = useState(null);
  const tableContainerRef = useRef(null);
  const tableMaxHeight = useTableMaxHeight(
    tableContainerRef,
    [loading, ProductList?.length, rowsPerPage, page, selectedTab]
  );
  const serviceTabsRootRef = useRef(null);
  const [canScrollServiceTabsLeft, setCanScrollServiceTabsLeft] = useState(false);
  const [canScrollServiceTabsRight, setCanScrollServiceTabsRight] = useState(false);
  const [progress, setProgress] = useState(null)
  const [avatarUrl, setAvatarUrl] = useState(null)
  const [localPreview, setLocalPreview] = useState(null);
  const [selectedExistingServiceTemplate, setSelectedExistingServiceTemplate] = useState(null);
  const location = useLocation();
  const receivedData = location.state?.data;
  const [avaTaxCategory, setAvaTaxCategory] = useState([])
  const [columnWidths, setColumnWidths] = useState({});
  const [headerOrder, setHeaderOrder] = useState([]);
  const headerOrderInitialized = useRef({});
  const [allAccounts,setAllAccounts]= useState([])
   

  const handleScrollLeft = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleScrollRight = () => {
    if (tableContainerRef.current) {
      const maxScrollLeft = tableContainerRef.current.scrollWidth - tableContainerRef.current.clientWidth;
      tableContainerRef.current.scrollTo({
        left: maxScrollLeft,
        behavior: 'smooth',
      });
    }
  };

  const getServiceTabsScroller = () =>
    serviceTabsRootRef.current?.querySelector('.MuiTabs-scroller');

  const updateServiceTabsScrollState = useCallback(() => {
    const scroller = getServiceTabsScroller();
    if (!scroller) {
      setCanScrollServiceTabsLeft(false);
      setCanScrollServiceTabsRight(false);
      return;
    }
    const { scrollLeft, scrollWidth, clientWidth } = scroller;
    setCanScrollServiceTabsLeft(scrollLeft > 2);
    setCanScrollServiceTabsRight(scrollLeft + clientWidth < scrollWidth - 2);
  }, []);

  const scrollServiceTabs = (direction) => {
    const scroller = getServiceTabsScroller();
    if (!scroller) return;
    const step = Math.max(scroller.clientWidth * 0.6, 160);
    scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  useEffect(() => {
    const scroller = getServiceTabsScroller();
    if (!scroller) return undefined;

    updateServiceTabsScrollState();
    scroller.addEventListener('scroll', updateServiceTabsScrollState);
    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(updateServiceTabsScrollState)
      : null;
    resizeObserver?.observe(scroller);
    window.addEventListener('resize', updateServiceTabsScrollState);
    const initTimer = setTimeout(updateServiceTabsScrollState, 0);

    return () => {
      clearTimeout(initTimer);
      scroller.removeEventListener('scroll', updateServiceTabsScrollState);
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updateServiceTabsScrollState);
    };
  }, [updateServiceTabsScrollState, fromEstimateJob]);

  useEffect(() => {
    const scroller = getServiceTabsScroller();
    if (!scroller) return;
    const activeTab = scroller.querySelector('.MuiTab-root.Mui-selected');
    activeTab?.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    const timer = setTimeout(updateServiceTabsScrollState, 150);
    return () => clearTimeout(timer);
  }, [selectedTab, updateServiceTabsScrollState]);

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilterName(filterName);
    }, 300);
    return () => clearTimeout(timer);
  }, [filterName]);

  const getAllWorkflows = async () => {
    try {
      axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-services`)
        .then((res) => {
          // Sort workflows alphanumerically by name
          const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setWorkflows(sortedWorkflows)
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }

      const fetchAllAvalaraTaxCategories = async()=>{
        try {
           const response = await axios.post(`${REST_API_END_POINT}avalara/get-all-tax-category`);
           console.log("fetchAllAvalaraTaxCategories",response?.data?.result)
           // Sort Avalara tax categories alphanumerically by description
           const sortedTaxCategories = [...(response?.data?.result || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
           setAvaTaxCategory(sortedTaxCategories)
        } catch (error) {
          console.error('Error fetching Avalara tax categories:', error);
          
        }
      }

  // Load column widths from localStorage on mount and when tab changes
  useEffect(() => {
    const storageKey = `labourCostList_columnWidths_${selectedTab}`;
    const savedWidths = localStorage.getItem(storageKey);
    if (savedWidths) {
      try {
        setColumnWidths(JSON.parse(savedWidths));
      } catch (error) {
        console.error('Error loading column widths:', error);
      }
    }
  }, [selectedTab]);

  // Load header order from localStorage on mount and when tab changes
  useEffect(() => {
    const storageKey = `labourCostList_headerOrder_${selectedTab}`;
    const savedOrder = localStorage.getItem(storageKey);
    if (savedOrder) {
      try {
        const parsedOrder = JSON.parse(savedOrder);
        if (Array.isArray(parsedOrder) && parsedOrder.length > 0) {
          setHeaderOrder(parsedOrder);
          headerOrderInitialized.current[selectedTab] = true;
        } else {
          setHeaderOrder([]);
          headerOrderInitialized.current[selectedTab] = false;
        }
      } catch (error) {
        console.error('Error loading header order:', error);
        setHeaderOrder([]);
        headerOrderInitialized.current[selectedTab] = false;
      }
    } else {
      setHeaderOrder([]);
      headerOrderInitialized.current[selectedTab] = false;
    }
  }, [selectedTab]);

  // Save column widths to localStorage
  const handleColumnResize = useCallback((columnId, newWidth) => {
    setColumnWidths((prev) => {
      const updated = { ...prev, [columnId]: newWidth };
      const storageKey = `labourCostList_columnWidths_${selectedTab}`;
      localStorage.setItem(storageKey, JSON.stringify(updated));
      return updated;
    });
  }, [selectedTab]);

  // Handle header reorder
  const handleHeaderReorder = useCallback((draggedIndex, dropIndex) => {
    setHeaderOrder((prevOrder) => {
      const newOrder = [...prevOrder];
      const [removed] = newOrder.splice(draggedIndex, 1);
      newOrder.splice(dropIndex, 0, removed);
      const storageKey = `labourCostList_headerOrder_${selectedTab}`;
      localStorage.setItem(storageKey, JSON.stringify(newOrder));
      return newOrder;
    });
  }, [selectedTab]);

  const fetchAllQbAccounts =async()=>{
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-qb-accounts`)
      if(response.data.status===1){
        setAllAccounts(response.data.result)
      }else{
        setAllAccounts([])
      }
      
    } catch (error) {
      console.log('error',error)
    }
  }


  useEffect(() => {
    if (allAccounts.length === 0) {
      fetchAllQbAccounts();
    }
    getAllWorkflows();
    fetchAllAvalaraTaxCategories();
  }, []);

  useEffect(() => {
    let isCurrent = true;
    setLoading(true);

    const fetchServices = async () => {
      try {
        const response = await axios.post(`${REST_API_END_POINT}product/get-all-labour-cost-services-filtered`, {
          page: page + 1,
          rowsPerPage,
          selectedTab,
          search: debouncedFilterName,
          order,
          orderBy,
        });
        if (!isCurrent) return;

        const productListData = response.data.results;
        if (productListData) {
          setProductList(productListData);
          setTotalCount(
            Number(
              response?.data?.totalCount ??
                response?.data?.pagination?.totalCount ??
                productListData.length ??
                0
            )
          );
        } else {
          setProductList([]);
          setTotalCount(0);
        }
        const serviceTypeData = response.data.serviceTypes;
        if (serviceTypeData) {
          const sortedServiceTypes = [...(serviceTypeData || [])].sort((a, b) =>
            alphanumericCompare(a?.name || '', b?.name || '')
          );
          setLabourCostServiceTypes(sortedServiceTypes);
        } else {
          setLabourCostServiceTypes([]);
        }
        setRefreshData(false);
      } catch (error) {
        if (!isCurrent) return;
        console.error('Error fetching data:', error);
      } finally {
        if (isCurrent) {
          setLoading(false);
          setRefreshData(false);
        }
      }
    };

    fetchServices();
    return () => {
      isCurrent = false;
    };
  }, [page, rowsPerPage, selectedTab, debouncedFilterName, refreshData, receivedData, order, orderBy]);

  // Keep highlight state in sync with server-side "isNew" flag
  useEffect(() => {
    const serverNewIds = (ProductList || [])
      .filter((item) => Number(item?.isNew) === 1)
      .map((item) => Number(item.id));
    setRecentlyMovedIds(serverNewIds);
  }, [ProductList]);

  ///this is for the tabs for inHouse and SubContract
  const handleTabChange = (event, newValue) => {
    if (newValue === 'in_house') {
      setInHouse(1)
    } else if (newValue === 'sub_contract') {
      setInHouse(0)
    } else if (newValue === 'install') {
      setInHouse(2)
    } else if (newValue === 'ts') {
      setInHouse(3)
    } else if (newValue === 'estimate_services') {
      setInHouse(4)
    } else if (newValue === 'design_services') {
      setInHouse(5)
    } else if (newValue === 'admin_services') {
      setInHouse(6)
    } else {
      setInHouse(1)
    }
    setSelectedTab(newValue);
    setSelected([]);
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = slicedData.map((n) => n.id);
      const newSelectedNames = slicedData.map((n) => n.name);
      setSelected(newSelecteds);
      setSelectedNames(newSelectedNames);
      return;
    }
    setSelected([]);
    setSelectedNames([]);
  };

  const handleClick = (event, id, name) => {
    const selectedIndex = selected.indexOf(id);
    const selectedNameIndex = selectedNames.indexOf(name);
    let newSelected = [];
    let newselectedNames = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
      newselectedNames = newselectedNames.concat(selectedNames, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newselectedNames = newselectedNames.concat(selectedNames.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newselectedNames = newselectedNames.concat(selectedNames.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      newselectedNames = newselectedNames.concat(selectedNames.slice(0, selectedNameIndex), selectedNames.slice(selectedNameIndex + 1));
    }
    setSelected(newSelected);
    setSelectedNames(newselectedNames);
  };

  const handleSetData = (name, service_type, markup, total_cost, cost, id, inhouse, workflow, avatarUrl, makeAsTask,jobCost, makeInstallCard, taxable,taxCodeId,taxCode, qb_income_account, qb_expense_account,description) => {
    setSingleData({ name, service_type, markup, total_cost, cost, id, workflow, avatarUrl, makeAsTask,jobCost, makeInstallCard, taxable ,taxCodeId,taxCode, qb_income_account, qb_expense_account,description});
    setAvatarUrl(avatarUrl);
    setInHouse(inhouse);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // setSelected([]);
    // setSelectedNames([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useLayoutEffect(() => {
    if (skipPaginationScrollRef.current) {
      skipPaginationScrollRef.current = false
      return
    }
    const anchor = paginationScrollAnchorRef.current
    const run = () => scrollDashboardAncestorsToTop(anchor)
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [page, rowsPerPage])

  useEffect(() => {
    const prev = prevLoadingForPaginationScrollRef.current
    prevLoadingForPaginationScrollRef.current = loading
    if (prev !== true || loading !== false) return
    const anchor = paginationScrollAnchorRef.current
    const run = () => scrollDashboardAncestorsToTop(anchor)
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [loading])

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };

  const handleDeleteUser = (id, name, status) => {
    try {
      const values = {}
      values.id = Number(id)
      values.name = name
      values.status = status
      values.userId = userData.user_id
      axios.post(`${REST_API_END_POINT}product/delete-labour-cost-services`, values, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
        } else if (response.data.status === 0) {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
        setRefreshData(!refreshData)
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleMoveService = async (row, targetInhouse) => {
    if (row?.status !== 1) {
      enqueueSnackbar('Inactive service. Please activate to move.', { variant: 'warning' });
      return;
    }
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/move-labour-cost-service`, {
        id: row.id,
        targetInhouse,
        userId: userData?.user_id
      });
      const moveMessage = response?.data?.message || 'Service moved successfully';
      const variant = response?.data?.status === 1 ? 'success' : 'error';
      enqueueSnackbar(moveMessage, { variant });
      if (response?.data?.status === 1) {
        setRefreshData(!refreshData);
        // Add to recently moved list for highlighting
        setRecentlyMovedIds((prev) => {
          const newIds = Array.isArray(response?.data?.result?.updatedIds)
            ? response?.data?.result?.updatedIds.map(id => Number(id))
            : [Number(row.id)];
          return [...new Set([...prev, ...newIds])];
        });
      }
    } catch (error) {
      console.error('Error moving service', error);
      enqueueSnackbar('Failed to move service', { variant: 'error' });
    }
  };

  const handleBulkMoveSelected = async (targetInhouse) => {
    try {
      // Filter out inactive services before sending to API
      const activeServiceIds = selected.filter(serviceId => {
        const service = ProductList.find(s => s.id === serviceId);
        return service?.status === 1;
      });

      if (activeServiceIds.length === 0) {
        enqueueSnackbar('No active services selected to move.', { variant: 'warning' });
        return;
      }

      const response = await axios.post(`${REST_API_END_POINT}product/move-labour-cost-service`, {
        ids: activeServiceIds,
        targetInhouse,
        userId: userData?.user_id
      });

      const { successCount, failCount, updatedIds } = response?.data?.result || { successCount: 0, failCount: 0, updatedIds: [] };

      if (successCount > 0) {
        enqueueSnackbar(`${successCount} service${successCount > 1 ? 's' : ''} moved successfully${failCount > 0 ? `, ${failCount} failed` : ''}`, { variant: 'success' });
      }
      if (failCount > 0 && successCount === 0) {
        enqueueSnackbar(`${failCount} service${failCount > 1 ? 's' : ''} failed to move`, { variant: 'error' });
      }

      setSelected([]);
      setSelectedNames([]);
      setRefreshData(!refreshData);
      // Add to recently moved list for highlighting
      if (successCount > 0 && updatedIds && updatedIds.length > 0) {
        setRecentlyMovedIds((prev) => {
          const newIds = updatedIds.map(id => Number(id));
          return [...new Set([...prev, ...newIds])];
        });
      }
    } catch (error) {
      console.error('Error bulk moving services', error);
      enqueueSnackbar('Failed to move services', { variant: 'error' });
    }
  };

  const handleViewService = async (row) => {
    const id = row?.id;
    if (!id) return;
    // Optimistically clear highlight
    setRecentlyMovedIds((prev) => prev.filter((pid) => pid !== id));
    setProductList((prev = []) =>
      prev.map((item) => (item.id === id ? { ...item, isNew: 0 } : item))
    );

    setViewData(row);

    try {
      await axios.post(`${REST_API_END_POINT}product/mark-labour-service-viewed`, { id });
    } catch (error) {
      // Non-blocking: keep UI updated even if call fails
      console.error('Failed to clear new flag', error);
    }
  };

  const handleConfirm = async (values, setSubmitting, resetForm, setErrors) => {
    try {
      setOpenConfirm(false)
      if (data) {
        values.id = isEditingExistingService ? Number(data.labour_cost_service_id) : data.id;
        values.userId = userData.user_id;
        values.status = 1;
      } else {
        values.userId = userData.user_id;
        values.status = 1;
      }
      values.inHouse = Number(inHouse ?? 0);
      values.workflow = values.workflows?.id || null;

      let serviceId = null;
      await axios.post(
        REST_API_END_POINT + (data ? 'product/update-labour-cost-services' : 'product/add-labour-cost-services'),
        values,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      ).then((res) => {
        let data = res.data;
        serviceId = data?.service_id;
        resetForm();
        setSubmitting(false);
        setRefreshData(!refreshData);
        setFieldValue('avatarUrl', null);
        setAvatarUrl(null)
        setLocalPreview(null)
        if (selectedTab == 'in_house') {
          setInHouse(1);
        } else if (selectedTab === 'sub_contract') {
          setInHouse(0);
        } else if (selectedTab === 'install') {
          setInHouse(2);
        } else if (selectedTab === 'ts') {
          setInHouse(3);
        } else if (selectedTab === 'estimate_services') {
          setInHouse(4);
        } else if (selectedTab === 'design_services') {
          setInHouse(5);
        } else {
          setInHouse(1);
        }
        enqueueSnackbar(`${data.message}`, { variant: data.status === 1 ? 'success' : 'error' });
      }).catch((error) => {
        console.error(error);
        setSubmitting(false);
        setErrors(error);
        setFieldValue('avatarUrl', null);
        setAvatarUrl(null)
        setLocalPreview(null)
      });

      setSingleData(null);
      setAdd(false);
      if(fromEstimateJob){
        // Pass row snapshot so parent can replace the correct line after async refresh (await in parent).
        onClose(serviceId, selectedServiceForCatalog)
        setOpenServiceModal(false);
        setSelectedServiceForCatalog(null);
      }
    } catch (error) {
      console.error(error);
      setSubmitting(false);
      setErrors(error);
      setFieldValue('avatarUrl', null);
      setAvatarUrl(null)
      setLocalPreview(null)
    } finally {
      setConfirmLoading(false);
      if(fromEstimateJob){
        setOpenServiceModal(false);
        setSelectedServiceForCatalog(null);
      }
    }
  };

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Please enter the service name')
      .matches(/^[^\t\n\r:]+$/, 'Name cannot contain colons(:)'),
    // .matches(/^[a-zA-Z0-9\s\-]+$/, 'Name can only contain letters, numbers, spaces, and hyphens'),
    type: Yup.object().nullable().required('Please select the service type'),
    markup: inHouse && Yup.number().typeError('Please enter a valid number').required('Please enter the markup'),
    cost: inHouse && Yup.number().typeError('Please enter a valid number').required('Please enter the cost'),
    workflows: Yup.object().nullable()//.required('Workflows is required'),
    // workflows: inHouse && Yup.object().nullable().required('Workflows is required'),
  })
  const isExistingEstimateServiceMode = Boolean(
    fromEstimateJob && selectedServiceForCatalog?.is_existing_service
  );
  const isEditingExistingService = Boolean(
    fromEstimateJob &&
      selectedServiceForCatalog?.labour_cost_service_id &&
      !selectedServiceForCatalog?.serviceRepickMode
  );

  useEffect(() => {
    if (selectedServiceForCatalog?.serviceRepickMode) {
      setSelectedExistingServiceTemplate(null)
    }
  }, [
    selectedServiceForCatalog?.serviceRepickMode,
    selectedServiceForCatalog?.indexId,
    selectedServiceForCatalog?.newIndexId,
  ])

  useEffect(() => {
    if(selectedServiceForCatalog){
      setSingleData(selectedServiceForCatalog);
    }
  }, [selectedServiceForCatalog]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: serviceNameForAdd ? serviceNameForAdd : data?.name || '',
      description: serviceDescForAdd ? serviceDescForAdd : data?.description || '',
      type:
        selectedServiceForCatalog?.serviceRepickMode
          ? null
          : data?.service_type
            ? labourCostServiceTypes?.find(item => data.service_type === item.id)
            : null,
      markup: data ? data?.markup : '',
      total_cost: data?.total_cost ?? '',
      cost: data?.cost ?? '',
      workflows: selectedServiceForCatalog?.serviceRepickMode
        ? null
        : data?.workflow
          ? workflows?.find(item => data.workflow === item.id)
          : null,
      avatarUrl: data?.avatarUrl || null,
      makeAsTask: data?.makeAsTask || 0,
      jobCost: data?.jobCost || 0,
      makeInstallCard: data?.makeInstallCard || 0,
      taxable: data?.taxable || 0,
      taxCodeId: data?.taxCodeId || null,
      taxCode: data?.taxCode || '',
      qb_income_account: data?.qb_income_account ? allAccounts?.find(account => account.glCode == data?.qb_income_account) : null,
      qb_expense_account: data?.qb_expense_account ? allAccounts?.find(account => account.glCode == data?.qb_expense_account) : null,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        setConfirmLoading(true);
        if(selectedServiceForCatalog?.is_existing_service){
          if(fromEstimateJob){
            const serviceId = selectedExistingServiceTemplate?.id;
            onClose(serviceId, selectedServiceForCatalog)
            setOpenServiceModal(false);
            setSelectedServiceForCatalog(null);
            return;
          }
        }
        if (data) {
          if (inHouse) {
            if (data.cost === values.cost) {
              await handleConfirm(values, setSubmitting, resetForm, setErrors);
            } else {
              setOpenConfirm(true);
            }
          } else {
            await handleConfirm(values, setSubmitting, resetForm, setErrors);
          }
        } else {
          await handleConfirm(values, setSubmitting, resetForm, setErrors);
        }
      } catch (error) {
        setFieldValue('avatarUrl', null);
        setAvatarUrl(null)
        setLocalPreview(null)
        console.error(error);
        setSubmitting(false);
        setErrors(error);
        setConfirmLoading(false);
      }
      // try {
      //   if (data) {
      //     values.id = data.id
      //     values.userId = userData.user_id
      //     values.status = 1
      //   } else {
      //     values.userId = userData.user_id
      //     values.status = 1
      //   }
      //   values.inHouse=inHouse ? 1 : 0
      //   axios.post(REST_API_END_POINT + (data ? 'product/update-labour-cost-services' : 'product/add-labour-cost-services'), values,
      //     {
      //       headers: {
      //         'Content-Type': 'application/json',
      //       },
      //     })
      //     .then((res) => {
      //       let data = res.data;
      //       resetForm();
      //       setSubmitting(false);
      //       setRefreshData(!refreshData)
      //       setInHouse(true)
      //       enqueueSnackbar(`${data.message}`, { variant: data.status == 1 ? 'success' : 'error' });
      //     }).catch((error) => {
      //       console.error(error);
      //     })
      //   setSingleData(null)
      //   setAdd(false)

      // } catch (error) {
      //   console.error(error);
      //   setSubmitting(false);
      //   setErrors(error);
      // }
    },
  })
  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik

  useEffect(() => {
    if (!openEditServiceModal || !selectedServiceForCatalog) return;

    const nextType =
      selectedServiceForCatalog?.service_type != null
        ? (labourCostServiceTypes || []).find(
            (item) =>
              Number(item?.id) === Number(selectedServiceForCatalog?.service_type),
          ) || null
        : null;

    const nextWorkflow =
      selectedServiceForCatalog?.workflow != null
        ? (workflows || []).find(
            (item) =>
              Number(item?.id) === Number(selectedServiceForCatalog?.workflow),
          ) || null
        : null;

    setFieldValue('type', nextType);
    setFieldValue('workflows', nextWorkflow);
  }, [
    openEditServiceModal,
    selectedServiceForCatalog,
    labourCostServiceTypes,
    workflows,
    setFieldValue,
  ]);

  const applyExistingServiceTemplate = useCallback((service) => {
    if (!service) return;

    // Copy all fields from selected service into the form (keep current name as-is)
    const nextType =
      service?.service_type != null
        ? (labourCostServiceTypes || []).find((t) => Number(t?.id) === Number(service?.service_type)) || null
        : null;
    const nextWorkflow =
      service?.workflow != null
        ? (workflows || []).find((w) => Number(w?.id) === Number(service?.workflow)) || null
        : null;

    setInHouse(Number(service?.inhouse ?? inHouse ?? 0));
    setFieldValue('type', nextType);
    setFieldValue('workflows', nextWorkflow);
    setFieldValue('markup', service?.markup ?? '');
    setFieldValue('cost', service?.cost ?? '');
    setFieldValue('total_cost', service?.total_cost ?? '');
    setFieldValue('makeAsTask', service?.makeAsTask ?? 0);
    setFieldValue('jobCost', service?.jobCost ?? 0);
    setFieldValue('makeInstallCard', service?.makeInstallCard ?? 0);
    setFieldValue('taxable', service?.taxable ?? 0);
    setFieldValue('taxCodeId', service?.taxCodeId ?? null);
    setFieldValue('taxCode', service?.taxCode ?? '');
    setFieldValue('avatarUrl', service?.avatarUrl ?? null);
    setAvatarUrl(service?.avatarUrl ?? null);
    setLocalPreview(null);
  }, [inHouse, labourCostServiceTypes, setFieldValue, workflows]);

const closeServiceModalNow = () => {
    if (closeAutoSaveSourceRef.current === 'cancel') {
      setSingleData(null)
      setAdd(false)
      formik.resetForm()
      handleRemoveAll()
      if(fromEstimateJob){
        setOpenServiceModal(false);
        setSelectedServiceForCatalog(null);
      }
    } else {
      setSingleData(null)
      setAdd(false)
      if(fromEstimateJob){
        setOpenServiceModal(false);
        setSelectedServiceForCatalog(null);
      }
    }
  }

  const requestCloseServiceModal = (source = 'modal') => {
    closeAutoSaveSourceRef.current = source
    setOpenCloseAutoSaveConfirm(true)
  }

  const filteredUsers = ProductList || [];
  const slicedData = filteredUsers;
  const isUserNotFound = !loading && filteredUsers.length === 0;

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }))

  // Function to render table cell based on header ID
  const renderTableCell = (headerId, row, headerIndex, allHeaders) => {
    const { id, name, type_name, service_type, markup, total_cost, cost, workflow, inhouse, timestamp,qb_income_account,qb_expense_account,
      status, authorized_by, syncWithQuickbooks, avatarUrl, makeAsTask, jobCost, makeInstallCard, taxCode, taxCodeId, originInhouse, isNew, description } = row;
    const statusText = (status === 1) ? "Active" : "Inactive";
    const originLabel = getInhouseLabel(originInhouse ?? inhouse);
    
    switch (headerId) {
      case 'qb':
        return (
          <TableCell key="qb" padding="qb" align="left" sx={{ 
            maxWidth: columnWidths['qb'] || '40px', 
            width: columnWidths['qb'] || '40px', 
            minWidth: columnWidths['qb'] || '40px',
            padding: '8px 4px !important' 
          }}>
            <Avatar src={QbLogo} sx={{ width: 24, height: 24, objectFit: "cover", display: syncWithQuickbooks === 1 ? 'flex' : 'none' }} alt='qb' />
          </TableCell>
        );
      case 'name':
        return (
          <TableCell key="name" component="th" scope="row" align="left" padding="none" sx={{ 
            cursor: 'pointer', 
            minWidth: columnWidths['name'] || '150px', 
            maxWidth: columnWidths['name'] || '200px',
            width: columnWidths['name'] || 'auto'
          }}>
            <Tooltip title={name}>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{
                  cursor: 'pointer',
                  maxWidth: {xs: 200, sm: 90, md: 90, lg: 90, xl: 440},
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: 500,
                  fontSize: '0.75rem'
                }}
                onClick={() => handleViewService(row)}
              >
                {name}
              </Typography>
            </Tooltip>
          </TableCell>
        );
      case 'type_name':
        return (
          <TableCell key="type_name" align="left" sx={{ 
            fontSize: '0.75rem', 
            maxWidth: columnWidths['type_name'] || {xs: 300, sm: 100, md: 100, lg: 100, xl: 440},
            width: columnWidths['type_name'] || 'auto',
            minWidth: columnWidths['type_name'] || 'auto'
          }}>
            <Tooltip title={type_name || ''} arrow>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{
                  fontSize: '0.75rem',
                  maxWidth: {xs: 300, sm: 100, md: 100, lg: 100, xl: 440},
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {type_name}
              </Typography>
            </Tooltip>
          </TableCell>
        );
      case 'makeAsTask':
        return (
          <TableCell key="makeAsTask" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['makeAsTask'] || 'auto',
            minWidth: columnWidths['makeAsTask'] || 'auto',
            maxWidth: columnWidths['makeAsTask'] || 'none'
          }}>
            <Typography variant={"body2"} sx={{ color: makeAsTask == 1 ? theme.palette.warning.dark : theme.palette.mode === 'light' ? theme.palette.error.main : '#ffffff', fontSize: '0.75rem' ,fontWeight: 700 }}>
              {makeAsTask === 1 ? 'Yes' : 'No'}
            </Typography>
          </TableCell>
        );
      case 'makeInstallCard':
        return (
          <TableCell key="makeInstallCard" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['makeInstallCard'] || 'auto',
            minWidth: columnWidths['makeInstallCard'] || 'auto',
            maxWidth: columnWidths['makeInstallCard'] || 'none'
          }}>
            <Typography variant={"body2"} sx={{ color: makeInstallCard == 1 ? theme.palette.warning.dark : theme.palette.mode === 'light' ? theme.palette.error.main : '#ffffff', fontSize: '0.75rem' ,fontWeight: 700 }}>
              {makeInstallCard === 1 ? 'Yes' : 'No'}
            </Typography>
          </TableCell>
        );
      case 'jobCost':
        return (
          <TableCell key="jobCost" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['jobCost'] || 'auto',
            minWidth: columnWidths['jobCost'] || 'auto',
            maxWidth: columnWidths['jobCost'] || 'none'
          }}>
            <Typography variant={"body2"} sx={{ color: jobCost == 1 ? theme.palette.warning.dark : theme.palette.mode === 'light' ? theme.palette.error.main : '#ffffff', fontSize: '0.75rem' ,fontWeight: 700 }}>
              {jobCost === 1 ? 'Yes' : 'No'}
            </Typography>
          </TableCell>
        );
      case 'cost':
        return (
          <TableCell key="cost" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['cost'] || 'auto',
            minWidth: columnWidths['cost'] || 'auto',
            maxWidth: columnWidths['cost'] || 'none'
          }}>
            {'$' + cost}
          </TableCell>
        );
      case 'markup':
        return (
          <TableCell key="markup" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['markup'] || 'auto',
            minWidth: columnWidths['markup'] || 'auto',
            maxWidth: columnWidths['markup'] || 'none'
          }}>
            {markup ? markup?.toFixed(2) : 0.00}
          </TableCell>
        );
      case 'total_cost':
        return (
          <TableCell key="total_cost" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['total_cost'] || 'auto',
            minWidth: columnWidths['total_cost'] || 'auto',
            maxWidth: columnWidths['total_cost'] || 'none'
          }}>
            {total_cost ? total_cost?.toFixed(2) : 0.00}
          </TableCell>
        );
      case 'originInhouse':
        return (
          <TableCell key="originInhouse" align="left" sx={{ 
            fontSize: '0.75rem',
            width: columnWidths['originInhouse'] || 'auto',
            minWidth: columnWidths['originInhouse'] || 'auto',
            maxWidth: columnWidths['originInhouse'] || 'none'
          }}>
            {originLabel}
          </TableCell>
        );
      case 'service':
        if (selectedTab === 'inactive_services') {
          return (
            <TableCell key="service" align="left" sx={{ 
              fontSize: '0.75rem',
              width: columnWidths['service'] || 'auto',
              minWidth: columnWidths['service'] || 'auto',
              maxWidth: columnWidths['service'] || 'none'
            }}>
              {getInhouseLabel(inhouse)}
            </TableCell>
          );
        }
        return null;
      case 'status':
        return (
          <TableCell key="status" align="left" sx={{ 
            width: columnWidths['status'] || 'auto',
            minWidth: columnWidths['status'] || 'auto',
            maxWidth: columnWidths['status'] || 'none'
          }}>
            <Label
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color={(status === 1 && 'info') || 'error'}
              sx={{ fontSize: '0.7rem', py: 0.25, px: 0.75 }}
            >
              {sentenceCase(statusText)}
            </Label>
          </TableCell>
        );
      case 'options':
        const moveToProduction = (selectedTab === 'install' || selectedTab === 'ts' || selectedTab === 'sub_contract' || selectedTab === 'estimate_services' || selectedTab === 'design_services' || selectedTab === 'admin_services') ? () => handleMoveService(row, 1) : undefined;
        const moveToInstall = (selectedTab === 'in_house' || selectedTab === 'ts' || selectedTab === 'sub_contract' || selectedTab === 'estimate_services' || selectedTab === 'design_services' || selectedTab === 'admin_services') ? () => handleMoveService(row, 2) : undefined;
        const moveToTS = (selectedTab === 'in_house' || selectedTab === 'install' || selectedTab === 'sub_contract' || selectedTab === 'estimate_services' || selectedTab === 'design_services' || selectedTab === 'admin_services') ? () => handleMoveService(row, 3) : undefined;
        const moveToSubContract = (selectedTab === 'in_house' || selectedTab === 'install' || selectedTab === 'ts' || selectedTab === 'estimate_services' || selectedTab === 'design_services' || selectedTab === 'admin_services') ? () => handleMoveService(row, 0) : undefined;
        const moveToEstimateServices = (selectedTab === 'in_house' || selectedTab === 'install' || selectedTab === 'ts' || selectedTab === 'sub_contract' || selectedTab === 'design_services' || selectedTab === 'admin_services') ? () => handleMoveService(row, 4) : undefined;
        const moveToDesignServices = (selectedTab === 'in_house' || selectedTab === 'install' || selectedTab === 'ts' || selectedTab === 'sub_contract' || selectedTab === 'estimate_services' || selectedTab === 'admin_services') ? () => handleMoveService(row, 5) : undefined;
        const moveToAdminServices = (selectedTab === 'in_house' || selectedTab === 'install' || selectedTab === 'ts' || selectedTab === 'sub_contract' || selectedTab === 'estimate_services' || selectedTab === 'design_services') ? () => handleMoveService(row, 6) : undefined;
        return (
          <TableCell key="options" align="left" sx={{ 
            width: columnWidths['options'] || 'auto',
            minWidth: columnWidths['options'] || 'auto',
            maxWidth: columnWidths['options'] || 'none'
          }}>
            {(id == 10) ?
              <UserMoreMenu
                onEdit={() => {
                  if (status == 1) {
                    if (explodedPermissions?.some(permission => ['Edit services'].includes(permission))) {
                      handleSetData(name, service_type, markup, total_cost, cost, id, inhouse, workflow, avatarUrl, row.makeAsTask, row.jobCost, row.makeInstallCard, row.taxable, taxCodeId, taxCode, qb_income_account, qb_expense_account, description)
                    } else {
                      enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                    }
                  } else {
                    enqueueSnackbar('Inactive service. Please activate to edit.', { variant: 'warning' });
                  }
                }}
                text={status === 0 ? 'Activate' : null}
                onMoveToProduction={moveToProduction}
                onMoveToInstall={moveToInstall}
                onMoveToTS={moveToTS}
                onMoveToSubContract={moveToSubContract}
                onMoveToEstimateServices={moveToEstimateServices}
                onMoveToDesignServices={moveToDesignServices}
                onMoveToAdminServices={moveToAdminServices}
              />
              :
              <UserMoreMenu
                onEdit={() => {
                  if (status == 1) {
                    if (explodedPermissions?.some(permission => ['Edit services'].includes(permission))) {
                      handleSetData(name, service_type, markup, total_cost, cost, id, inhouse, workflow, avatarUrl, row.makeAsTask, row.jobCost, row.makeInstallCard, row.taxable, taxCodeId, taxCode, qb_income_account, qb_expense_account, description)
                    } else {
                      enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                    }
                  } else {
                    enqueueSnackbar('Inactive service. Please activate to edit.', { variant: 'warning' });
                  }
                }}
                text={status === 0 ? 'Activate' : null}
                onDeactivate={() => {
                  if (explodedPermissions?.some(permission => ['Activate/Deactivate Services'].includes(permission))) {
                    handleDeleteUser(id, name, status === 1 ? 0 : 1)
                  } else {
                    enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                  }
                }}
                onDelete={() => {
                  if (explodedPermissions?.some(permission => ['Delete Services'].includes(permission))) {
                    setIsDelete(true)
                    setId(id)
                  } else {
                    enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                  }
                }}
                onMoveToProduction={moveToProduction}
                onMoveToInstall={moveToInstall}
                onMoveToTS={moveToTS}
                onMoveToSubContract={moveToSubContract}
                onMoveToEstimateServices={moveToEstimateServices}
                onMoveToDesignServices={moveToDesignServices}
                onMoveToAdminServices={moveToAdminServices}
              />
            }
            <ConfirmationPopup open={isDelete} handleClick={() => handleDeleteUser(Id, name, 2)} message={'You want to Delete this service!'} handleClose={() => setIsDelete(false)} />
          </TableCell>
        );
      case '':
        // Empty header cells (for scroll buttons) - first empty header is scroll right, last is scroll left
        const emptyHeaderIndices = allHeaders.map((h, idx) => h.id === '' ? idx : -1).filter(idx => idx !== -1);
        const isFirstEmpty = emptyHeaderIndices.length > 0 && headerIndex === emptyHeaderIndices[0];
        const isLastEmpty = emptyHeaderIndices.length > 0 && headerIndex === emptyHeaderIndices[emptyHeaderIndices.length - 1];
        
        if (isFirstEmpty) {
          // First empty header - scroll right button
          return (
            <TableCell key="scroll-right" padding="checkbox" align="left" onClick={handleScrollRight} sx={{ padding: '8px 4px !important', width: '40px' }}>
              <IconButton sx={{ backgroundColor: theme.palette.divider, width: "28px", height: "28px", padding: 0 }} >
                <ArrowForwardIos color="#ffffff" sx={{ width: "16px", fontSize: '0.875rem' }} />
              </IconButton>
            </TableCell>
          );
        } else if (isLastEmpty) {
          // Last empty header - scroll left button
          return (
            <TableCell key="scroll-left" padding="checkbox" align="left" onClick={handleScrollLeft} sx={{ padding: '8px 4px !important', width: '40px' }}>
              <IconButton sx={{ backgroundColor: theme.palette.divider, width: "28px", height: "28px", padding: 0 }} >
                <ArrowBackIos color="#ffffff" sx={{ width: "16px", ml: 0.5, fontSize: '0.875rem' }} />
              </IconButton>
            </TableCell>
          );
        }
        // Other empty headers (if any) - return null
        return null;
      default:
        return null;
    }
  };

  const dynamicTableHead = (() => {
    const baseHead = selectedTab === 'sub_contract' 
      ? [...TABLE_HEAD_SUBCONT] 
      : selectedTab === 'inactive_services' 
        ? [...TABLE_HEAD_Inactive] 
        : [...TABLE_HEAD];

    // Separate empty headers (for scroll buttons) from regular headers
    const emptyHeaders = baseHead.filter(h => h.id === '');
    const firstEmptyHeader = emptyHeaders[0];
    const lastEmptyHeader = emptyHeaders.length > 1 ? emptyHeaders[emptyHeaders.length - 1] : emptyHeaders[0];
    const regularHeaders = baseHead.filter(h => h.id !== '');

    // Check localStorage directly if headerOrder state is empty (during initial load)
    let orderToUse = headerOrder;
    if (headerOrder.length === 0) {
      const storageKey = `labourCostList_headerOrder_${selectedTab}`;
      const savedOrder = localStorage.getItem(storageKey);
      if (savedOrder) {
        try {
          const parsedOrder = JSON.parse(savedOrder);
          if (Array.isArray(parsedOrder) && parsedOrder.length > 0) {
            orderToUse = parsedOrder;
            // Update state asynchronously to avoid render issues
            if (!headerOrderInitialized.current[selectedTab]) {
              setTimeout(() => {
                setHeaderOrder(parsedOrder);
                headerOrderInitialized.current[selectedTab] = true;
              }, 0);
            }
          }
        } catch (error) {
          console.error('Error parsing saved header order:', error);
        }
      }
    }

    // Apply header order if available (only for regular headers, exclude empty headers)
    if (orderToUse.length > 0) {
      const orderedHead = [];
      const regularHeadersMap = new Map(regularHeaders.map(h => [h.id, h]));
      
      // Reorder based on saved order, preserving only headers that exist in regularHeaders
      // Filter out empty headers from orderToUse
      const regularOrder = orderToUse.filter(id => id !== '');
      regularOrder.forEach((id) => {
        const header = regularHeadersMap.get(id);
        if (header) {
          orderedHead.push(header);
          regularHeadersMap.delete(id);
        }
      });
      
      // Add any remaining headers that weren't in the saved order (new headers)
      regularHeadersMap.forEach((header) => {
        orderedHead.push(header);
      });
      
      // Always place empty headers in fixed positions: first empty at start, last empty at end
      const finalOrderedHead = [];
      if (firstEmptyHeader) {
        finalOrderedHead.push(firstEmptyHeader);
      }
      finalOrderedHead.push(...orderedHead);
      if (lastEmptyHeader && lastEmptyHeader !== firstEmptyHeader) {
        finalOrderedHead.push(lastEmptyHeader);
      }
      
      // Update header order if structure changed (new headers added)
      const currentOrder = finalOrderedHead.map(h => h.id);
      if (currentOrder.length !== orderToUse.length) {
        const storageKey = `labourCostList_headerOrder_${selectedTab}`;
        localStorage.setItem(storageKey, JSON.stringify(currentOrder));
        if (headerOrder.length > 0) {
          setHeaderOrder(currentOrder);
        }
      }
      
      return finalOrderedHead;
    }

    // Initialize header order on first load (when headerOrder is empty and not yet initialized for this tab)
    if (orderToUse.length === 0 && baseHead.length > 0 && !headerOrderInitialized.current[selectedTab]) {
      const initialOrder = baseHead.map(h => h.id);
      const storageKey = `labourCostList_headerOrder_${selectedTab}`;
      localStorage.setItem(storageKey, JSON.stringify(initialOrder));
      headerOrderInitialized.current[selectedTab] = true;
      setHeaderOrder(initialOrder);
    }

    return baseHead;
  })();

  const handleSwitchInhouse = (event) => {
    if (event.target.checked) {
      setSelectedTab('in_house')
      setInHouse(1)
    } else {
      setSelectedTab('sub_contract')
      setInHouse(0)
    }
  }

  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     console.log("Uploaded Data Type:", typeof acceptedFiles, acceptedFiles);

  //     // Ensure acceptedFiles is an array
  //     const filesArray = Array.isArray(acceptedFiles) ? acceptedFiles : [acceptedFiles];

  //     if (filesArray.length > 0) {
  //       const file = filesArray[0]; // Always pick the first file
  //       console.log("Selected File:", file);

  //       // **CLEAR PREVIOUS IMAGE**
  //       if (localPreview) {
  //         URL.revokeObjectURL(localPreview);
  //       }

  //       // Generate a new local preview
  //       const previewUrl = URL.createObjectURL(file);
  //       setLocalPreview(previewUrl); // ✅ Show new preview immediately
  //       console.log("Generated Local Preview:", previewUrl);

  //       // Upload to Firebase
  //       const Filename = `${new Date().getTime()}_${file.name}`;
  //       const StorageRef = ref(storage, Filename);
  //       const uploadTask = uploadBytesResumable(StorageRef, file);

  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round(
  //             (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //           );
  //           setProgress(progress);
  //           console.log(`Upload Progress: ${progress}%`);
  //         },
  //         (error) => {
  //           console.error("Upload Error:", error.message);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //             console.log("Firebase Download URL:", downloadURL);
  //             setAvatarUrl(downloadURL); // ✅ Store only the final URL
  //             setLocalPreview(null); // ✅ Clear local preview after upload
  //           });
  //         }
  //       );
  //     } else {
  //       console.log("No files selected.");
  //     }
  //   },
  //   [localPreview, setLocalPreview, setAvatarUrl, setProgress]
  // );


  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     const filesArray = Array.isArray(acceptedFiles) ? acceptedFiles : [acceptedFiles];
  //     if (filesArray.length > 0) {
  //       const file = filesArray[0];
  //       const localPreview = URL.createObjectURL(file);
  //       setLocalPreview(localPreview)
  //       const Filename = `${new Date().getTime()}_${file.name}`;
  //       const StorageRef = ref(storage, Filename);
  //       const uploadTask = uploadBytesResumable(StorageRef, file);
  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round(
  //             (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //           );
  //           setProgress(progress);
  //           console.log(`Upload Progress: ${progress}%`);
  //         },
  //         (error) => {
  //           console.error("Upload Error:", error.message);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //             setFieldValue('avatarUrl', downloadURL);
  //             setAvatarUrl(downloadURL);
  //             URL.revokeObjectURL(localPreview);
  //           });
  //         }
  //       );
  //     } else {
  //       console.log("No files selected.");
  //     }
  //   },
  //   [setFieldValue, setProgress]
  // );

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const filesArray = Array.isArray(acceptedFiles) ? acceptedFiles : [acceptedFiles];

      if (filesArray.length > 0) {
        const file = filesArray[0];
        const localPreview = URL.createObjectURL(file);
        setLocalPreview(localPreview);

        const timestamp = Date.now();
        const sanitizedName = file.name.replace(/\s+/g, '_');
        const fileName = `${timestamp}_${sanitizedName}`;
        const filePath = `inventory/services/design/${fileName}`; // ✅ updated path

        try {
          setProgress(1); // Initial progress

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to get public URL');
          }

          setFieldValue('avatarUrl', publicUrlData.publicUrl);
          setAvatarUrl(publicUrlData.publicUrl);
          URL.revokeObjectURL(localPreview);
          setProgress(100);
        } catch (err) {
          console.error('Upload failed:', err.message);
          setProgress(0);
        }
      } else {
        console.log("No files selected.");
      }
    },
    [setFieldValue, setProgress]
  );

  const handleRemoveAll = () => {
    setFieldValue('avatarUrl', null);
    setAvatarUrl(null)
    setLocalPreview(null)
  }

  const handleRemove = (file) => {
    setFieldValue('avatarUrl', null);
    setAvatarUrl(null)
    setLocalPreview(null)
  }

  const getAccountOptions = (allAccounts, fieldType, materialTypeId) => {
    const INCOME_ALLOWED = [
      'Income',
      'Other Income',
      'Cost of Goods Sold',
      'Expense',
      'Other Expense',
    ];
  
    const EXPENSE_ALLOWED = [
      'Expense',
      'Other Expense',
      'Cost of Goods Sold',
      'Income',
      'Other Income',
    ];
  
    // Filter for 'income' fieldType
    if (fieldType === 'income') {
      let filteredAccounts = allAccounts.filter(acc =>
        INCOME_ALLOWED.includes(acc.accountType)
      );
  
      // If materialTypeId = 1, only allow "SalesOfProductIncome"
      if (materialTypeId === 1) {
        filteredAccounts = filteredAccounts.filter(acc =>
          acc.detailType === 'SalesOfProductIncome'
        );
      }
  
      return filteredAccounts;
    }
  
    // Filter for 'expense' fieldType
    if (fieldType === 'expense') {
      let filteredAccounts = allAccounts.filter(acc =>
        EXPENSE_ALLOWED.includes(acc.accountType) && acc.accountType !== 'Expense'
      );
  
      if (materialTypeId === 1) {
        filteredAccounts = filteredAccounts.filter(acc =>
          acc.accountType !== 'Income'
        );
      }
  
      return filteredAccounts;
    }
  
    return [];
  };

  return (
    <Page title={`Services : List | ${COMPANY_NAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs
            heading="Services"
          />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              onClick={() => navigate(PATH_DASHBOARD.products.labourType)}
              variant="contained"
            >
              Service Types
            </Button>
            <Button
              disabled={explodedPermissions?.some(permission => ['Add services'].includes(permission)) ? false : true}
              onClick={() => { setAdd(true) }}
              variant="outlined"
              startIcon={<Icon icon={plusFill} />}
            >
              Add Services
            </Button>
          </Box>
        </Stack>
        {
          isExistingEstimateServiceMode ? '' :
        <Card>
          <Box display="flex" justifyContent={'space-between'}>
            <Box flexShrink={0}>
              <ProductToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                selectedName={selectedNames}
                selected={selected}
                onDelete={() => { setSelected([]); setPage(0); }}
                item="services"
                selectedTab={selectedTab}
                showActiveInactive={true}
                userId={userData?.user_id}
                setRefreshData={setRefreshData}
                refreshData={refreshData}
                onMoveSelected={handleBulkMoveSelected}
                rowCount={slicedData?.length}
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                minWidth: 0,
                maxWidth: '100%',
                display: 'flex',
                alignItems: 'center',
                mt: 3,
                gap: 0.5,
              }}
            >
              <IconButton
                size="small"
                aria-label="Scroll service tabs left"
                onClick={() => scrollServiceTabs(-1)}
                disabled={!canScrollServiceTabsLeft}
                sx={{
                  flexShrink: 0,
                  backgroundColor: theme.palette.divider,
                  width: 28,
                  height: 28,
                  '&.Mui-disabled': { opacity: 0.35 },
                }}
              >
                <ArrowBackIos sx={{ width: 14, fontSize: '0.875rem', ml: 0.5 }} />
              </IconButton>
              <Box ref={serviceTabsRootRef} sx={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons={false}
                  aria-label="Services origin tabs"
                  sx={{
                    minHeight: 48,
                    '& .MuiTabs-scroller': {
                      overflowX: 'auto !important',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': { display: 'none' },
                    },
                    '& .MuiTab-root': {
                      minWidth: 'auto',
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                      textTransform: 'none',
                      px: 2,
                    },
                  }}
                >
                  <Tab value={"in_house"} label="Production" />
                  <Tab value={'sub_contract'} label="Sub Contract" />
                  <Tab value={'install'} label="Install" />
                  <Tab value={'ts'} label="T/S" />
                  <Tab value={'estimate_services'} label="Estimate Services" />
                  <Tab value={'design_services'} label="Design Services" />
                  <Tab value={'admin_services'} label="Admin Services" />
                  <Tab value={'inactive_services'} label="Inactive Services" />
                </Tabs>
              </Box>
              <IconButton
                size="small"
                aria-label="Scroll service tabs right"
                onClick={() => scrollServiceTabs(1)}
                disabled={!canScrollServiceTabsRight}
                sx={{
                  flexShrink: 0,
                  backgroundColor: theme.palette.divider,
                  width: 28,
                  height: 28,
                  '&.Mui-disabled': { opacity: 0.35 },
                }}
              >
                <ArrowForwardIos sx={{ width: 14, fontSize: '0.875rem' }} />
              </IconButton>
            </Box>
          </Box>
          <Box ref={paginationScrollAnchorRef}>
          <Scrollbar>
            <TableContainer
              ref={tableContainerRef}
              sx={{
                minWidth: 800,
                whiteSpace: "nowrap",
                overflowX: "auto",
                maxHeight: tableMaxHeight,
                overflowY: "auto",
                '&::-webkit-scrollbar': {
                  width: '0.6em',
                  height: '0.6em',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#1e1e1e',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#555',
                  borderRadius: '6px',
                  border: '2px solid #1e1e1e',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#888',
                },
                '&::-webkit-scrollbar-corner': {
                  backgroundColor: '#1e1e1e',
                },
              }}>
              <Table 
                stickyHeader
                sx={{
                  '& .MuiTableCell-head': {
                    padding: '8px 12px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    height: '48px',
                    minHeight: '48px',
                    maxHeight: '48px',
                    lineHeight: 1.4,
                    whiteSpace: 'pre-line',
                    textAlign: 'left',
                    verticalAlign: 'middle'
                  },
                  '& .MuiTableSortLabel-root': {
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    justifyContent: 'flex-start',
                    whiteSpace: 'pre-line',
                    '& .MuiTableSortLabel-icon': {
                      marginLeft: '4px'
                    }
                  }
                }}
              >
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={dynamicTableHead}
                  rowCount={slicedData?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  showAllCheckBox
                  columnWidths={columnWidths}
                  onColumnResize={handleColumnResize}
                  showSeparators={true}
                  onHeaderReorder={handleHeaderReorder}
                />
                <TableBody>
                  {loading ? (
                    <LoadingScreen
                      sx={{
                        top: 0,
                        left: 0,
                        width: 1,
                        zIndex: 9999,
                        position: 'fixed',
                      }}
                    />
                  ) : (
                    <>
                      {!isUserNotFound &&
                      slicedData?.map((row) => {
                        let { id, name, type_name, service_type, markup, total_cost, cost, workflow, inhouse, timestamp,qb_income_account,qb_expense_account,
                          status, authorized_by,syncWithQuickbooks,avatarUrl, makeAsTask, jobCost, makeInstallCard,taxCode,taxCodeId, originInhouse, isNew } = row;
                        let statusText;
                        (status === 1) ? statusText = "Active" : statusText = "Inactive";
                        const isItemSelected = selected.indexOf(id) !== -1;
                        const isRecentlyMoved = Number(isNew) === 1 || recentlyMovedIds.includes(id);
                        const originLabel = getInhouseLabel(originInhouse ?? inhouse);
                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                            sx={{
                              backgroundColor: isRecentlyMoved ? 'rgba(255, 193, 7, 0.18)' : 'inherit',
                              border: isRecentlyMoved ? '1px solid rgba(255, 193, 7, 0.45)' : undefined,
                              transition: 'background-color 0.3s ease',
                              '& .MuiTableCell-root': {
                                padding: '8px 12px',
                                fontSize: '0.75rem',
                                height: 'auto',
                                lineHeight: 1.4
                              }
                            }}
                          >
                            <TableCell padding="checkbox" align="center" sx={{ padding: '8px 4px !important', width: '40px' }}>
                              <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, id, name)} size="small" />
                            </TableCell>

                            {/* Render cells based on dynamicTableHead order */}
                            {dynamicTableHead.map((header, index) => {
                              const cell = renderTableCell(header.id, row, index, dynamicTableHead);
                              return cell;
                            }).filter(cell => cell !== null)}
                          </TableRow>
                        );
                      })}
                    </>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={selectedTab === 'sub_contract' ? TABLE_HEAD_SUBCONT?.length : selectedTab === 'inactive_services' ? TABLE_HEAD_Inactive?.length : TABLE_HEAD?.length || 8} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={debouncedFilterName?.trim() ? debouncedFilterName : ''} msg="Services" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            // rowsPerPageOptions={[5, 10, 25]}
            rowsPerPageOptions={[25, 50, 100, 500]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          </Box>
        </Card>
        }
      </Container>
      <Modal
        modalTitle={'View Services'}
        open={viewData ? true : false}
        handleClose={() => {
          setViewData(null)
        }}
      >
        <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
          <Grid item xs={12} md={12}>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              spacing={3}
            >
              <Paper
                key={'ddf'}
                sx={{
                  p: 3,
                  width: 1,
                  bgcolor: 'background.neutral'
                }}
              >
                <Typography variant="subtitle1" gutterBottom>
                  <span style={{ color: viewData?.name ? 'inherit' : 'inherit' }}>
                    Name : {viewData?.name}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.type_name ? 'inherit' : 'inherit' }}>
                    Service Type : {viewData?.type_name}
                  </span>
                </Typography>
                {['in_house','install','ts','estimate_services','design_services','admin_services'].includes(selectedTab) && (<Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.workflow ? 'inherit' : 'inherit' }}>
                    Workflow : {workflows?.find(item => viewData?.workflow === item.id)?.name || ''}
                  </span>
                </Typography>)}
                {/* {selectedTab==='in_house'&&( */}
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.cost ? 'inherit' : 'inherit' }}>
                    {/* Cost (Hourly) : {viewData?.cost ? '$' + viewData?.cost : null} */}
                    Cost (Hourly) : {viewData?.cost || viewData?.cost === 0 ? '$' + viewData?.cost : null}
                  </span>
                </Typography>
                {/* )} */}
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.markup ? 'inherit' : 'inherit' }}>
                    Markup (%) : {viewData?.markup}
                  </span>
                </Typography>
                {/* {selectedTab==='in_house'&&( */}
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.total_cost ? 'inherit' : 'inherit' }}>
                    Total cost : {viewData?.total_cost}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: 'inherit' }}>
                    Origin : {getInhouseLabel(viewData?.originInhouse ?? viewData?.inhouse)}
                  </span>
                </Typography>
                {/* )} */}
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.authorized_by ? 'inherit' : 'inherit' }}>
                    Added By : {viewData?.authorized_by}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.timestamp ? 'inherit' : 'inherit' }}>
                    Added On : {viewData?.timestamp ? moment.unix(viewData?.timestamp).format('MM/DD/YYYY') : null}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.timestamp ? 'inherit' : 'inherit' }}>
                   Avalara Tax Category : {avaTaxCategory?.find(val =>viewData?.taxCodeId == val.taxCodeId)?.description}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.timestamp ? 'inherit' : 'inherit' }}>
                   QB Income Account : {viewData?.qb_income_account? allAccounts?.find(account => account.glCode == viewData?.qb_income_account)?.name : ''}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <span style={{ color: viewData?.timestamp ? 'inherit' : 'inherit' }}>
                   QB Expense Account : {viewData?.qb_expense_account? allAccounts?.find(account => account.glCode == viewData?.qb_expense_account)?.name : ''}
                  </span>
                </Typography>

                
                <FormControlLabel
                  control={
                    <Switch
                      checked={viewData?.makeAsTask === 1}
                      readOnly
                      color="primary"
                    />
                  }
                  label="Make as Task"
                />
                <FormControlLabel
                        control={
                          <Switch
                            checked={viewData?.makeInstallCard === 1}
                            readOnly
                            color="primary"
                          />
                        }
                        label="Make Install Card"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={viewData?.jobCost === 1}
                            readOnly
                            color="primary"
                          />
                        }
                        label="Job Cost"
                      />
                {/* <FormControlLabel
                        control={
                          <Switch
                            checked={viewData?.taxable === 1}
                            readOnly
                            color="primary"
                          />
                        }
                        label="Taxable"
                      /> */}
                <Typography variant="body2" gutterBottom sx={{ mt: 1 }}>
                  Status :{' '}
                  <Label
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={(viewData?.status === 1 && 'success') || 'error'}
                  >
                    {(viewData?.status === 1) ? " Active" : " Inactive"}
                  </Label>
                </Typography>
              </Paper>
              <Box
                sx={{
                  mt: 3,
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    setViewData(null)
                  }}
                >
                  Close
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        modalTitle={openEditServiceModal && isEditingExistingService ? 'Edit Existing Service' : isExistingEstimateServiceMode ? 'Choose Existing Service' : (data ? 'Edit Service' : 'Add Service')}
        open={add || data}
        handleClose={() => {
          requestCloseServiceModal('modal')
        }}
        width={1000}
      >
        <FormikProvider value={formik}>
          <Stack sx={{height:isExistingEstimateServiceMode ? 150 : '70vh',overflow:'scroll',overflowX:'hidden',overflowY: isExistingEstimateServiceMode ? 'visible' : 'auto',}}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid
              container
              sx={{ alignItems: 'center', justifyContent: 'center' }}
              spacing={3}
            >
              <Grid item xs={12} md={8}>
                {confirmLoading ?
                  <LoadingScreen />
                  :
                  <Stack spacing={3}>
                    {!isExistingEstimateServiceMode && (
                      <Typography variant='h6' gutterBottom>
                        {getInhouseLabel(inHouse)}
                      </Typography>
                    )}
                    {/* <FormControlLabel
                      control={
                        <Switch
                          checked={inHouse !== 0}
                          onChange={handleSwitchInhouse}
                        />
                      }
                      label={inHouse === 0 ? "Sub Contract" : inHouse === 2 ? "Install" : inHouse === 3 ? "T/S" : "In House"}
                    /> */}
                    {fromEstimateJob && !openEditServiceModal && filteredServices?.length > 0 ? (
                      <Autocomplete
                      fullWidth
                      id="combo-box-demo"
                      value={isEditingExistingService ? (selectedExistingServiceTemplate || filteredServices?.find((item) => Number(item?.id) === Number(selectedServiceForCatalog?.labour_cost_service_id)) || null) : selectedExistingServiceTemplate}
                      options={
                        filteredServices?.filter(
                          (item) =>
                            item.service_type != 44 && item.is_service_row !== 1 &&
                          item.status === 1  
                        ) || []
                      }                       
                      onChange={(event, newValue) => {
                        setSelectedExistingServiceTemplate(newValue || null);
                        applyExistingServiceTemplate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} 
                          label="Select a service" />
                      )}
                      sx={{mt:1}}
                      getOptionLabel={(option) => option.name ? option.name : ''}
                      isOptionEqualToValue={(option, value) => Number(option?.id) === Number(value?.id)}
                    />
                    ) :''
                    }
                    {
                      isExistingEstimateServiceMode ? '' :
                    <>
                    <Stack
                      direction={{ xs: 'column', sm: 'column' }}
                      spacing={{ xs: 3, sm: 2 }}
                    >
                      <Box
                        sx={{
                          backgroundColor: 'background.paper',
                          position: 'sticky',
                          top: "-10px",
                          paddingTop: "17px",
                          zIndex: 2,
                          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                          paddingBottom: 2,
                        }}
                      >
                        <TextField
                          fullWidth
                          label="Service Name"
                          {...getFieldProps('name')}
                          error={Boolean(touched.name && errors.name)}
                          helperText={touched.name && errors.name}
                        />
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          sx={{ mt: 3 }}
                          label="Description"
                          {...getFieldProps('description')}
                          error={Boolean(touched.description && errors.description)}
                          helperText={touched.description && errors.description}
                        />
                      </Box>
                      <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        // options={
                        //   [...(labourCostServiceTypes || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                        // }
                        options={
                          (fromEstimateJob 
                            ? labourCostServiceTypes?.filter(option => option.id !== 44) // Exclude id 44 when fromEstimateJob is true
                            : labourCostServiceTypes) // Include all options when fromEstimateJob is false
                            ?.sort((a, b) => alphanumericCompare(a?.name || '', b?.name || '')) // Then sort the options
                        }                        
                        value={values.type}
                        onChange={(event, newValue) => {
                          setFieldValue('type', newValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.type && errors.type)}
                            helperText={touched.type && errors.type}
                            label="Select a service type" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                      <>
                        <LabelStyle>Upload Design</LabelStyle>
                        <UploadSingleImage
                          showPreview
                          allowDownload
                          maxSize={1024 * 1024 * 1024}
                          accept="image/*"
                          // file={localPreview}
                          file={values?.avatarUrl}
                          onDrop={handleDrop}
                          onRemove={handleRemove}
                          onRemoveAll={handleRemoveAll}
                        />
                      </>
                      {/* {inHouse && */}
                      <TextField
                        fullWidth
                        label="Cost (Hourly)"
                        type="number"
                        // {...getFieldProps('cost')}
                        value={values?.cost}
                        onChange={(event, newValue) => {
                          // Prevent negative values
                          if (event.target.value < 0 || event.target.value === '-') {
                            return;
                          }
                          setFieldValue('cost', event.target.value)
                          // if (event.target.value) {
                            if (event.target.value !== '' && event.target.value !== null && event.target.value !== undefined) {
                            let value = event.target.value
                            let cost = parseFloat(value).toFixed(2)
                            const totalCost = Number(cost) + ((Number(cost) * Number(values?.markup)) / 100)
                            // totalCost = totalCost ? totalCost?.toFixed(2) : 0
                            setFieldValue('total_cost', totalCost?.toFixed(2))
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(event) => {
                          // Prevent minus key in all variations
                          if (event.key === '-' || event.key === 'Subtract' || event.keyCode === 189 || event.keyCode === 109) {
                            event.preventDefault();
                          }
                        }}
                        onKeyPress={(event) => {
                          // if (event.key === '0' && event.target.value === '') {
                          //   event.preventDefault();
                          // }
                          if (event.key === '-') {
                            event.preventDefault();
                          }
                          // if (event.key === '.') {
                          //   event.preventDefault();
                          // }
                        }}
                        error={Boolean(touched.cost && errors.cost)}
                        helperText={touched.cost && errors.cost}
                      />
                      {/* } */}
                      <TextField
                        fullWidth
                        label="Markup (%)"
                        // {...getFieldProps('markup')}
                        value={values?.markup}
                        onChange={(event, newValue) => {
                          let value = event.target.value
                          let markUpData = parseFloat(value).toFixed(2)
                          setFieldValue('markup', value)
                          if (values?.cost) {
                            let cost = parseFloat(values?.cost).toFixed(2)
                            const totalCost = Number(cost) + ((Number(cost) * Number(markUpData)) / 100)
                            // totalCost = totalCost ? totalCost?.toFixed(2) : 0
                            setFieldValue('total_cost', totalCost?.toFixed(2))
                          }
                        }}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onKeyPress={(event) => {
                          // if (event.key === '0' && event.target.value === '') {
                          //   event.preventDefault();
                          // }
                          if (event.key === '-') {
                            event.preventDefault();
                          }
                        }}
                        error={Boolean(touched.markup && errors.markup)}
                        helperText={touched.markup && errors.markup}
                      />
                      {/* {inHouse &&  */}
                      <TextField
                        fullWidth
                        label="Total Cost"
                        {...getFieldProps('total_cost')}
                        type="number"
                        disabled
                        error={Boolean(touched.total_cost && errors.total_cost)}
                        helperText={touched.total_cost && errors.total_cost}
                      />
                      {/* } */}
                    </Stack>

                    {/* {inHouse &&  */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete
                        fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={
                          [...(workflows || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                        }
                        value={values.workflows}
                        onChange={(event, newValue) => setFieldValue('workflows', newValue)}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows}
                            label="Select a Service Workflow" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                    </Stack>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                       <Autocomplete fullWidth
                         // sx={{ width: 400 }}
                         id="combo-box-demo"
                         options={
                           [...(avaTaxCategory || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
                         }
                         value={avaTaxCategory.find((item) => item.taxCodeId == values.taxCodeId) || null}
                         onChange={(event, newvalue) =>{
                               if(newvalue){
                                 setFieldValue('taxCodeId', newvalue.taxCodeId);
                                 setFieldValue('taxCode', newvalue.taxCode);
                               }else{
                                 setFieldValue('taxCodeId', null);
                                 setFieldValue('taxCode', '');
                               }
                         }}
                         renderInput={(params) => (
                           <TextField {...params} required
                            //  error={Boolean(touched.category && errors.category)}
                            //  helperText={touched.category && errors.category}
                             label="Select Avalara Tax Category" />
                         )}
                         getOptionLabel={(option) => option.description ? option.description : ''}
                      
                       />
                      
                     </Stack>
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}> 

                      <Autocomplete
                        fullWidth
                       // sx={{ width: 400 }}                         
                       id="combo-box-demo"
                       options={getAccountOptions(allAccounts, 'income',values?.material_types?.id)}
                
                       value={values.qb_income_account}
                       onChange={(event,newvalue)=>setFieldValue('qb_income_account',newvalue)}
                       renderInput={(params) => (
                         <TextField {...params} 
                           error={Boolean(touched.qb_income_account && errors.qb_income_account)}
                           helperText={touched.qb_income_account && errors.qb_income_account} 
                           label="Income Accounts" 
                           InputProps={{
                             ...params.InputProps,
                             startAdornment: (
                               <InputAdornment position="start">
                                 <Tooltip title={`${values?.qb_income_account?.name? `${values?.qb_income_account?.name}` : ''}`}>
                                 <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                 </Tooltip>
                               </InputAdornment>
                             ),
                           }}
                         />
                       )}
                        getOptionLabel={(option) => option?.glCode ? `${option.glCode} (${option?.name})` : ''}
                      />

                      </Stack>
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}> 
                     <Autocomplete
                        fullWidth
                          // sx={{ width: 400 }}                         
                          id="combo-box-demo"
                          // options={allAccounts.filter(account => account.type !== "Income" && account.type !=="Accounts Payable"  && account.type !=="Accounts Receivable")}
                          options={getAccountOptions(allAccounts, 'expense',null)}
                       
                          value={values.qb_expense_account}
                          onChange={(event,newvalue)=>{
                            setFieldValue('qb_expense_account',newvalue)
                          }
                          }
                          renderInput={(params) => (
                            <TextField {...params} 
                              error={Boolean(touched.qb_expense_account && errors.qb_expense_account)}
                              helperText={touched.qb_expense_account && errors.qb_expense_account} 
                              label="Expense Accounts" 
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                      <Tooltip title={`${values?.qb_expense_account?.name? `${values?.qb_expense_account?.name}` : ''}`}>
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        getOptionLabel={(option) => option?.glCode ? `${option.glCode} (${option?.name})` : ''}
                      />
                      </Stack>



                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <FormControlLabel
                            control={
                              <Switch
                              checked={formik.values.makeAsTask === 1}
                              onChange={(e) => formik.setFieldValue('makeAsTask', e.target.checked ? 1 : 0)}
                              color="primary"
                              />
                            }
                            label="Make as Task"
                          />
                          <FormControlLabel
                            control={
                              <Switch
                              checked={formik.values.makeInstallCard === 1}
                              onChange={(e) => formik.setFieldValue('makeInstallCard', e.target.checked ? 1 : 0)}
                              color="primary"
                              />
                            }
                            label="Make Install Card"
                          />
                          <FormControlLabel
                            control={
                              <Switch
                              checked={formik.values.jobCost === 1}
                              onChange={(e) => formik.setFieldValue('jobCost', e.target.checked ? 1 : 0)}
                              color="primary"
                              />
                            }
                            label="Job Cost"
                          />
                          {/* <FormControlLabel
                              control={
                                <Switch
                                  checked={formik.values.taxable === 1}
                                  onChange={(e) => formik.setFieldValue('taxable', e.target.checked ? 1 : 0)}
                                  color="primary"
                                />
                              }
                              label="Taxable"
                            /> */}
                      </Stack>

                    {/* } */}
                      </>
                    }

                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 1,
                      }}
                    >
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}
                      >
                        {isExistingEstimateServiceMode ? 'Submit' : (data ? 'Save Changes' : 'Add service')}
                      </LoadingButton>
                      <Button
                        variant="outlined"
                        // type="submit"
                        onClick={() => {
                          setSingleData(null)
                          setAdd(false)
                          if(fromEstimateJob){
                            setOpenServiceModal(false);
                            setSelectedServiceForCatalog(null);
                          }
                          formik.resetForm()
                          handleRemoveAll()
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Stack>
                }
              </Grid>
            </Grid>
          </Form>
          </Stack>
          {openConfirm && (
            <ConfirmationPopup
              open={openConfirm}
              handleClick={() => {
                handleConfirm(
                  formik.values,
                  formik.setSubmitting,
                  formik.resetForm,
                  formik.setErrors
                );
              }}
              handleClose={() => setOpenConfirm(false)}
              message={
                <div>
                  <p>
                    Updating the price will affect the cost calculations in product formulas and catalogs.
                    Do you wish to proceed with this update?
                  </p>
                  <p style={{ color: '#FF4842', fontWeight: 'bold', marginTop: 8 }}>
                    NB: It will not affect the existing sales order estimates.
                  </p>
                </div>
              }
            />
          )}
          {openCloseAutoSaveConfirm && (
            <ConfirmationPopup
              open={openCloseAutoSaveConfirm}
              handleClick={() => {
                setOpenCloseAutoSaveConfirm(false)
                formik.submitForm()
              }}
              handleClose={() => {
                setOpenCloseAutoSaveConfirm(false)
                closeServiceModalNow()
              }}
              message={'Do you want to auto save this Service before closing?'}
            />
          )}
        </FormikProvider>
      </Modal>
    </Page>
  );
}
